//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: ['selection', 'ticket'],
  data() {
    return {
      loading: true,
      balance: null
    }
  },
  filters: {
    format_odds(value, oddsFormat) {
      return _.get(value, 'display_odds.' + oddsFormat, parseFloat(value.odds).toFixed(2))
    }
  },
  watch: {},
  computed: {
    stake: {
      get() {
        return _.get(this.$store.state.betslip, 'stakes.' + _.get(this.selection, 'outcome.id'))
      },
      set(value) {
        this.$store.commit('betslip/setStakes', { key: _.get(this.selection, 'outcome.id'), value: value })
      }
    },
    oddsChanged() {
      if (!this.selectionLive) return false
      return _.get(this.selection, 'outcome.odds') != _.get(this.selectionLive, 'odds')
    },
    betType() {
      return this.$store.state.betslip.betType
    },
    selections() {
      return this.$store.state.betslip.selections
    },
    selected() {
      let mySelections = _.map(this.$store.state.selections, 'outcome.id')
      return _.includes(mySelections, this.outcome.id)
    }
  },
  mounted() {},
  methods: {
    changeStake() {
      this.$store.commit('betslip/setStakeSingle', null)
    },
    remove(selection) {
      this.$store.commit('betbuilder/remove', selection.id)
      this.$store.commit('betbuilder/setError', null)
      if(this.selections == 0) {
        this.$store.commit('betbuilder/toggleBetslip', false)
      }
      this.$store.commit('setBetSlipType', 'betbuilder')
      this.$root.$emit('betbuilder_removed')
    },
  }
}
